/*
 * Created on Sat Mar 23 2019
 *
 * Copyright (c) 2019 Sébastien Hecart - Fahbe Mobile App
 *
 *
 *
 */
export default {
  LOGIN_USE_ACCOUNT: 'Ou utiliser un compte existant',
  WEB_ERROR_REGISTER: 'Veuillez remplir toutes les champs',
  ACCOUNT: {
    MENU: {
      account: 'Compte',
      password: 'Mot de passe',
      subscription: 'Mon abonnement',
      groupsubscription: 'Mon équipe',
      calcul: 'Calculs',
      bills: 'Facturation'
    },
    PROFIL: { 
      verifemail: 'E-mail changé avec succès. Un e-mail de confirmation vous a été envoyé',
      button: 'Enregistrer les modifications',
      email: 'Adresse e-mail',
      email_missing: 'Veuillez saisir un e-mail valide',
      user_use_provider:
        'Vous ne pouvez pas changer votre adresse e-mail car vous vous connectez en utilisez un service externe. (Google ou Facebook)'
    },
    PASSWORD: {
      previouspwd: 'Mot de passe actuel',
      newpwd: 'Nouveau mot de passe',
      repaeatpwd: 'Vérifiez le mot de passe',
      button: 'Enregistrer les modifications',
      error_oldPassword: 'Saississez le mot de passe',
      error_inconsistentPwd: 'Vérification du mot de passe incorrect',
      recover: 'Mot de passe oublié ?',
      success: 'Mot de passe mis à jour',
      resetmail: 'Un email vous a été envoyé pour réinitialiser votre mot de passe',
      unknow_error: 'Une erreur inconnue est survenue lors du changement de mot de passe. Veuillez contacter le support',
      user_use_provider:
        'Vous ne pouvez pas définir ou changer votre mot de passe car vous vous connectez en utilisez un service externe. (Google ou Facebook)'
    }
  },

  WEB: {
    COMMON: {
      required: 'Requis',
      firstname: 'Prénom (facultatif)',
      lastname: 'Nom (facultatif)',
      company: 'Entreprise (facultatif)'
    },
    LOAD: {
      saveName: 'Nom de la sauvegarde'
    },
    MAIL: {
      title: 'Télécharger votre simulation en PDF',
      subtitle: 'Choississer les éléments de customisation de votre PDF.',
      configure: 'Configurer vos données de génération de PDF'
    },
    MAILPROFILE: {
      title: 'Vos données de génération de PDF'
    },
    SUBSCRIPTION: {
      title: 'BatiKal Premium',
      titlecollab: 'Votre équipe BatiKal',
      description:
        "Cette section permet d'ajouter des comptes premium pour des collaborateurs/employés. Cela inclut l'accès au site et à l'application mobile",
      numberAbo: 'Membres ({{quantity}}) ',
      addNewEmployee: "Inviter d'autres personnes",
      isIos: "Pour gérer votre abonnement, utilisez l'application mobile sur votre appareil iOS",
      isAndroid: "Pour gérer votre abonnement, utilisez l'application mobile sur votre Android",
      isStripe:
        "Vous disposez d'un abonnement Premium souscrit sur notre site Web. Pour gérer votre abonnement, modifier vos coordonnées, accéder à vos factures, utilisez le lien ci-dessous",
      subscribe: "S'abonner"
    },
    GROUPSUB: {
      startProcessAddEmployee: 'Ajouter des comptes utilisateurs',
      step1_addemployee: 'Ajouter des comptes',
      step3_analyse: "Erreur d'utilisateur",
      step4_mail: "Personnalisation du mail d'invitation",
      step5_conformation: 'Confirmation',
      email_to_add: 'Adresse e-mail',

      addmail_action: 'Ajouter un compte',
      action_delete: 'Supprimer',
      action_add: 'Ajouter',
      action_name: 'Action',
      date_renew: 'Date validité abonnement',
      load_csv_file: 'Selectionner un fichier CSV',
      addingMail_error: "Certains utilisateurs ({{quantity}}) n'ont pas pu être ajoutés car ils bénéficient déjà d'un abonnement",
      default_mail: 'Nous avons le plaisir de vous informer que la société XXXX vous offre un abonnement au service BatiKal.'
    },
    BILLS: {
      title: 'Facturation'
    }
  }
}
